import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Mail, AlertCircle, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) { setErr(e2.response?.data?.detail || "Chyba pri odoslaní"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-[var(--wb-surface)] border border-zinc-800 p-8" data-testid="forgot-password-page">
        <div className="flex items-center gap-2 mb-8">
          <img src="/tigik-logo.png" alt="Tigik" className="w-10 h-10 object-cover border border-gold-600/40" />
          <span className="font-display font-black text-xl">TIGIK</span>
        </div>
        <h1 className="font-display font-bold text-3xl mb-1">Zabudnuté heslo</h1>
        <p className="text-sm text-zinc-500 mb-8 font-mono uppercase tracking-wider">→ reset link</p>

        {sent ? (
          <div data-testid="forgot-sent" className="border-l-2 border-green-500 bg-green-500/5 p-5">
            <CheckCircle2 className="w-8 h-8 text-green-500 mb-3" />
            <h2 className="font-display font-bold text-lg mb-1">Skontroluj svoj email</h2>
            <p className="text-sm text-zinc-400">
              Ak je <strong>{email}</strong> registrovaný, odoslali sme inštrukcie na obnovu hesla.
              Odkaz je platný 1 hodinu.
            </p>
            <Link to="/login" className="wb-btn-ghost inline-block mt-5 px-4 py-2 text-xs">Späť na prihlásenie</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <p className="text-sm text-zinc-400 mb-4">
              Zadaj email s ktorým si sa zaregistroval/a. Pošleme ti odkaz na nastavenie nového hesla.
            </p>
            <div>
              <label className="block text-xs font-mono uppercase tracking-wider text-zinc-500 mb-1">Email</label>
              <input data-testid="forgot-email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="wb-input w-full px-3 py-2 text-sm" />
            </div>
            {err && (
              <div className="flex items-center gap-2 p-2 border border-red-900 bg-red-950/30 text-red-400 text-sm">
                <AlertCircle className="w-4 h-4" /> {err}
              </div>
            )}
            <button data-testid="forgot-submit" type="submit" disabled={busy}
              className="wb-btn-primary w-full py-3 text-sm disabled:opacity-50 inline-flex items-center justify-center gap-2">
              <Mail className="w-4 h-4" /> Odoslať reset link
            </button>
            <div className="text-sm text-zinc-500 text-center">
              <Link to="/login" className="text-gold-500 hover:text-gold-400">← Späť na prihlásenie</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
